import { CustomerStatus } from '../models';
export const CUSTOMER_MOCK = {
    id: 'BAC_111_139_021_118',
    legacyId: {
        partnerNo: '41134',
    },
    status: CustomerStatus.Active,
    type: 'PERSONAL',
    distributorId: 'Raisin',
    distributionChannelId: 'raisin_direct_retail_deu',
    registrationDate: '2021-12-07',
    company: null,
    persons: [],
    address: {
        street: 'Friesenweg Ranch',
        streetNumber: '61b',
        additionalInformation: null,
        city: 'Holinskistadt',
        flatNumber: null,
        postalCode: '22264',
        countryCode: 'DEU',
    },
    deliveryAddress: null,
    _embedded: {
        persons: [
            {
                id: 'PER_100_000_001_815',
                personId: '28910013',
                firstName: 'Marie',
                lastName: 'Schwalm',
                birthDate: '1943-12-02',
                username: '2041134006',
                personalDetails: {
                    academicTitleCode: 'academic_title_dr_med',
                    courtesyTitleCode: 'courtesy_title_mr',
                    firstName: 'Marie',
                    lastName: 'Schwalm',
                    birthName: null,
                    birthDate: '1943-12-02',
                    birthPlace: 'Haverneyfeld',
                    birthCountryCode: 'DEU',
                    nationalityPrimary: 'DEU',
                    nationalitySecondary: null,
                    gender: 'gender_male',
                    maritalStatus: 'marital_status_widowed',
                    profession: 'profession_employee',
                    industry: null,
                },
                address: {
                    street: 'Friesenweg Ranch',
                    streetNumber: '61b',
                    additionalInformation: null,
                    city: 'Holinskistadt',
                    flatNumber: null,
                    postalCode: '22264',
                    countryCode: 'DEU',
                },
                contactDetails: {
                    email: 'tara.palmer-1638887711556@test.com',
                    phoneNumber: '+49151175497739',
                },
                taxDetails: [
                    {
                        taxIdentificationNumber: '44601235785',
                        countryCode: 'DEU',
                        precedence: 0,
                    },
                ],
                additionalFinancialInformation: {
                    pep: {
                        additionalInfo: 'PEP - Additional Information',
                        status: 'EXPOSED_DIRECTLY',
                    },
                    sourceOfFunds: {
                        originOfFunds: 'professional_income',
                        annualIncome: {
                            displayedText: 'EUR 20,000 to EUR 40,000',
                            code: 'income_range.2',
                        },
                    },
                },
                roles: [
                    {
                        id: '1',
                        name: 'ACCOUNT_HOLDER',
                        status: 'ACTIVE',
                    },
                ],
            },
        ],
        referenceAccounts: [
            {
                accountId: '28910026',
                accountHolder: 'Marie Schwalm',
                bankName: 'Landesbank Berlin - Berliner Sparkasse',
                bic: 'BELADEBEXXX',
                iban: 'DE42100500005365875853',
                accountNumber: '5365875853',
                branchCode: null,
                ccy: 'EUR',
            },
        ],
        dataValidity: null,
    },
};
//# sourceMappingURL=customer.js.map